import StoreDetailContainer from './StoreDetailContainer';
export default StoreDetailContainer;
